import { render, staticRenderFns } from "./templateSet.vue?vue&type=template&id=be133de0&scoped=true"
import script from "./templateSet.vue?vue&type=script&lang=js"
export * from "./templateSet.vue?vue&type=script&lang=js"
import style0 from "./templateSet.vue?vue&type=style&index=0&id=be133de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be133de0",
  null
  
)

export default component.exports